import { useMemo } from "react";
import { Link } from 'react-scroll';

// import icons
import callIcon from "../Assets/Icons/telephone-call-white.png";
import mailIcon from "../Assets/Icons/message-white.png";
import menuIcon from "../Assets/Icons/options.png";
import closeIcon from "../Assets/Icons/close.png";

// import components
import { Logo } from "./Logo";
import { handleMenu } from "../Services/Functions";

const NavBar = () => {

    const navLinks = useMemo(() => {
        return [
            {
                text: "Home",
                route: "home",
            },
            {
                text: "About Us",
                route: "about",
            },
            {
                text: "Services",
                route: "services",
            },
            {
                text: "Industries",
                route: "industry",
            },
            {
                text: "Founder",
                route: "founder",
            }
        ]
    }, []);

    return (
        <nav>
            <div className="nav-head">
                <div className="wrapper">
                    <div className="nav-icon-text-wrap">
                        <div className="nav-icon-text">
                            <img src={mailIcon} alt="callIcon" />
                            <p>info@pagepartners.co.za <span>|| cv@pagepartners.co.za</span></p>
                        </div>

                        <div className="nav-icon-text">
                            <img src={callIcon} alt="callIcon" />
                            <p>+27 10 001 5276 <span>|| +27 82 600 2410</span></p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wrapper">
                <div className="nav-wrap">
                    <div className="left">
                        <Logo />
                    </div>
                    <div className="right">
                        <button className="menu" onClick={() => handleMenu("open")}><img src={menuIcon} alt="menuIcon" /></button>
                        <div className="nav-links" id="nav-link">
                            <button title="Close" onClick={() => handleMenu("close")} id="close-btn"><img src={closeIcon} alt="close icon" /></button>

                            {navLinks.map((route, index) => (

                                <button key={index} title={route.text}>
                                    <Link className="link" to={route.route} smooth={true} duration={500}>
                                        {route.text}
                                    </Link>
                                </button>
                            ))}
                        </div>
                        <Link to="contact" smooth={true} duration={500}>
                            <button className="contact">Contact Us</button>
                        </Link>
                    </div>
                </div>
            </div>
        </nav>
    );
}
export default NavBar;